/** @format */

import React, { FC } from 'react'
import styled from 'styled-components'
import { DenoiseRuleProps } from '../constants'
import { Icon, Input, Select, Option, FormItem } from '@king-design/react'
import variable from 'src/static/styles/var'
import { AddButon } from 'src/components'
import { initDenoiseRule } from '../constants'
import { cloneDeep } from 'lodash'
import { uniqueValidate } from 'src/utils/formValidate'

interface MatchRuleProps {
  className?: string
  rules: DenoiseRuleProps[][]
  onChange: (rules: DenoiseRuleProps[][]) => void
}

const MatchRule: FC<MatchRuleProps> = ({ className, rules, onChange }) => {
  const onChangeRules = (ruleValues: DenoiseRuleProps[], orIndex: number, move?: 'up' | 'down') => {
    const copyRules = cloneDeep(rules)
    if (!ruleValues) {
      // 删除
      copyRules.splice(orIndex, 1)
    } else if (move === 'up') {
      // 上移
      if (orIndex > 0) {
        const temp = copyRules[orIndex - 1]
        copyRules[orIndex - 1] = copyRules[orIndex]
        copyRules[orIndex] = temp
      }
    } else if (move === 'down') {
      // 下移
      if (orIndex < copyRules.length - 1) {
        const temp = copyRules[orIndex + 1]
        copyRules[orIndex + 1] = copyRules[orIndex]
        copyRules[orIndex] = temp
      }
    } else {
      // 修改
      copyRules[orIndex] = ruleValues
    }
    onChange(copyRules)
  }

  return (
    <div className={className}>
      {rules?.map((orRule, orIndex) => {
        const hasSeverity = orRule.find(rule => rule.Type === 'severity')
        return (
          <div className="or_rule_item" key={orIndex}>
            <div className="or_rule_header">
              <p>#{orIndex + 1}.</p>
              <div className="ksc-space">
                {rules?.length > 1 ? (
                  <Icon
                    className="ion-trash-a"
                    size={16}
                    onClick={() => {
                      onChangeRules(undefined, orIndex)
                    }}
                  />
                ) : null}
                <Icon
                  className="k-icon-up"
                  size={16}
                  onClick={() => onChangeRules(orRule, orIndex, 'up')}
                />
                <Icon
                  className="k-icon-down"
                  size={16}
                  onClick={() => onChangeRules(orRule, orIndex, 'down')}
                />
              </div>
            </div>
            <div className="or_rule_content">
              {orRule.map((addRule, andIndex) => {
                const { Label, Operator, Type, Values } = addRule
                return (
                  <div className="or_rule_content_item" key={`${orIndex}_${andIndex}`}>
                    <FormItem hideLabel value={Type}>
                      {/* 类型： 标签 或 告警级别 */}
                      <Select
                        value={Type}
                        width={100}
                        onChangeValue={value => {
                          const copyOrRule = cloneDeep(orRule)
                          const andValue = {
                            Type: value,
                            Label: value === 'severity' ? 'severity' : '',
                            Operator: value === 'severity' ? '=' : Operator,
                            Values: []
                          }
                          copyOrRule[andIndex] = andValue
                          onChangeRules(copyOrRule, orIndex)
                        }}
                      >
                        <Option disabled={!!hasSeverity} value="severity">
                          告警级别
                        </Option>
                        <Option value="tag">标签</Option>
                      </Select>
                    </FormItem>
                    {/* 标签名 或 告警级别 */}
                    <FormItem
                      hideLabel
                      value={Label}
                      rules={{
                        required: true,
                        unique: value => {
                          return uniqueValidate(
                            value,
                            orRule,
                            'Label',
                            '同一个规则内，标签名不允许重复'
                          )
                        },
                        ruleLabelKey: true
                      }}
                    >
                      <Input
                        value={Label}
                        width={135}
                        placeholder="标签名"
                        disabled={Type === 'severity'}
                        onChangeValue={value => {
                          const copyOrRule = cloneDeep(orRule)
                          copyOrRule[andIndex].Label = value
                          onChangeRules(copyOrRule, orIndex)
                        }}
                      ></Input>
                    </FormItem>
                    {/* 操作符 */}
                    <FormItem hideLabel value={Operator}>
                      <Select
                        value={Operator}
                        width={135}
                        placeholder="操作符"
                        disabled={Type === 'severity'}
                        onChangeValue={value => {
                          const copyOrRule = cloneDeep(orRule)
                          copyOrRule[andIndex].Operator = value
                          onChangeRules(copyOrRule, orIndex)
                        }}
                      >
                        <Option value="=">等于(=)</Option>
                        {Type === 'tag' ? (
                          <>
                            <Option value="!=">不等于(!=)</Option>
                            <Option value="=~">正则匹配(=~)</Option>
                            <Option value="!~">正则不匹配(!~)</Option>
                          </>
                        ) : null}
                      </Select>
                    </FormItem>
                    {/* 告警级别值 或 标签值 */}
                    <FormItem
                      hideLabel
                      value={Values}
                      rules={{ required: true, denoiseRuleValuesValidate: Type === 'tag' }}
                    >
                      {Type === 'tag' ? (
                        <Input
                          width={280}
                          type="textarea"
                          placeholder="标签值，多个值换行分割"
                          value={Values.join('\n')}
                          rows={2}
                          onChangeValue={value => {
                            const copyOrRule = cloneDeep(orRule)
                            copyOrRule[andIndex].Values = value.split('\n')
                            onChangeRules(copyOrRule, orIndex)
                          }}
                        />
                      ) : (
                        <Select
                          value={Values}
                          width={280}
                          multiple
                          placeholder="告警级别，支持多选"
                          onChangeValue={value => {
                            const copyOrRule = cloneDeep(orRule)
                            copyOrRule[andIndex].Values = value
                            onChangeRules(copyOrRule, orIndex)
                          }}
                        >
                          <Option value="critical">critical</Option>
                          <Option value="error">error</Option>
                          <Option value="warning">warning</Option>
                        </Select>
                      )}
                    </FormItem>
                    {/* 删除 */}
                    {orRule?.length > 1 ? (
                      <Icon
                        className="ion-trash-a"
                        size={16}
                        onClick={() => {
                          const copyConditions = cloneDeep(orRule)
                          copyConditions.splice(andIndex, 1)
                          onChangeRules(copyConditions, orIndex)
                        }}
                      />
                    ) : null}
                  </div>
                )
              })}
              <div className="add_condition">
                <AddButon
                  text="添加串行条件"
                  size="small"
                  type="link"
                  fluid={false}
                  disabled={orRule?.length >= 20}
                  onClick={() => {
                    const copyConditions = orRule.concat([
                      {
                        ...initDenoiseRule,
                        Type: hasSeverity ? 'tag' : 'severity',
                        Label: hasSeverity ? '' : 'severity'
                      }
                    ])
                    onChangeRules(copyConditions, orIndex)
                  }}
                />
              </div>
            </div>
          </div>
        )
      })}
      <div className="add_condition">
        <AddButon
          text="添加并行条件"
          disabled={rules?.length >= 3}
          onClick={() => {
            const copyConditions = rules.concat([[initDenoiseRule]])
            onChange(copyConditions)
          }}
        />
      </div>
    </div>
  )
}

export default styled(MatchRule)`
  width: 720px;
  .or_rule_item {
    border: 1px solid #f0f0f0;
    border-radius: 2px;
    margin-bottom: 16px;
    .k-icon {
      cursor: pointer;
      &:hover {
        color: ${variable.primaryColor};
      }
    }
    .or_rule_header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 12px;
      height: 32px;
      line-height: 32px;
      border-bottom: 1px solid #f0f0f0;
      p {
        margin-bottom: 0;
      }
    }
    .or_rule_content {
      padding: 8px;
      .add_condition {
        text-align: right;
      }
      .or_rule_content_item {
        display: flex;
        align-items: flex-start;
        margin-bottom: 8px;
        & > * {
          margin-right: 8px;
          &:last-child {
            margin-right: 0;
          }
        }
        .ion-trash-a {
          width: 20px;
          text-align: center;
          line-height: 32px;
        }
      }
    }
  }
`
